import authorizationModule from "./authorizationModule"
import angular from "angular"

const ACCESS_DENIED_ERROR = "access denied"
const INVALID_GROUP_ERROR = "invalid group"

authorizationModule.config([function () {
}]).run(["$rootScope", "$state", "$injector", "$q", "permissionService", "authenticationService", "$timeout", "$location", function ($rootScope, $state, $injector, $q, permissionService, authenticationService, $timeout, $location) {

    $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {
        if (!authenticationService.isAuthenticated()) {
            return
        }
        if (error.toString() === ACCESS_DENIED_ERROR) {
            logError(`Group ${toState.data.group} without permission.`)
        } else if (error.toString() === INVALID_GROUP_ERROR) {
            logError(`State ${toState.name} without group.`)
        } else {
            logError("Error changing state", arguments)
        }
        return $state.go("r2.home")
    })

    function logError(message) {
        // eslint-disable-next-line no-console
        console.error(message)
    }

    $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
        if (toState.requiresAuthentication === false || toState.name === "login") {
            return
        }
        if (!authenticationService.isAuthenticated()) {
            event.preventDefault()
            $timeout(() => {
                authenticationService.setTargetState(toState, toParams)
                authenticationService.logOut()
                $location.path("/login")
            })
        }

        if (toState.name === "r2.home") {
            return
        }

        event.preventDefault()
        resolveGroupName()
            .then(redirectAccordingToPermission)
            .then(broadCastSuccess)
            .catch(broadCastError)

        function resolveGroupName() {
            let group = toState.data.group
            if (!toState.data.group) {
                return $q.reject(INVALID_GROUP_ERROR)
            }
            if (typeof group === "boolean") {
                return $q.when(group)
            } else if (angular.isString(group)) {
                return $q.when(group).then(canRead)
            } else if (angular.isArray(group) || angular.isFunction(group)) {
                let locals = {
                    "$stateParams": toParams
                }
                return $q.when($injector.invoke(group, null, locals)).then(canRead)
            } else {
                return $q.reject(new Error("toState have unknown or undefined data.group: " + toState.data.group))
            }
        }

        function canRead(groupName) {
            return permissionService.canRead(groupName)
        }

        function redirectAccordingToPermission(canRead) {
            if (canRead) {
                return $state.go(toState, toParams, {notify: false})
            } else {
                return $q.reject(ACCESS_DENIED_ERROR)
            }
        }

        function broadCastSuccess(state) {
            $rootScope.$broadcast("$stateChangeSuccess", state, toParams, fromState, fromParams)
        }

        function broadCastError(error) {
            $rootScope.$broadcast("$stateChangeError", toState, toParams, fromState, fromParams, error)
        }
    })
}])

